<template>
  <div :class="`bom-count-${bomItemCount}`">
    <div
      v-if="
        item && item.sectionOptionValues && item.sectionOptionValues.length > 0
      "
      class="section"
      :ref="item.sectionId"
    >
      <div class="section-hd">
        <h1 class="section-hd-text">{{ item.SectionLabel }}</h1>
      </div>
      <ul v-if="!item.isComplete" class="inputList">
        <li
          v-for="({
            LabelText,
            IsOptional,
            PlaceholderText,
            MoreInfo,
            MoreInfoResult,
            RulesKey,
            EnhancedSectionId,
            Values,
            DependentProperty,
            IsPart,
            DisplayPosition,
            OptionHeaderImage,
            OptionHeaderDescription
          },
          index) in item.sectionOptionValues"
          :key="`inputList-${index}`"
        >        
          <div
            v-if="
              showOption(IsOptional, Values) &&
                showOptionWithValues(IsOptional, Values)
            "
            class="option"
          >
            <div class="option-hd" v-if="RulesKey != 'SuiteTableWidthId' && RulesKey != 'HeightId' && RulesKey != 'TableBaseFinishId' && RulesKey != 'TableTopFinishId' " >
              <span class="option-hd-text">{{ LabelText }}</span>              
              <span class="option-hd-optional" v-if="IsOptional">optional</span>
            </div>
            <div class="option-hd" v-if="RulesKey == 'SuiteTableWidthId' || RulesKey == 'HeightId' || RulesKey == 'TableBaseFinishId' || RulesKey == 'TableTopFinishId' ">
              <span class="option-hd-text">{{ LabelText }}</span>              
              <span class="option-hd-optional" v-if="IsOptional && isCustomOptional ">optional</span>
            </div>

            <div class="option-bd">
              <a
                @click="
                  optionClickHandler(
                    Values,
                    LabelText,
                    DependentProperty,
                    IsPart,
                    IsOptional,
                    index,
                    OptionHeaderImage,
                    OptionHeaderDescription
                  )
                "
                type="text"
                v-show="showOptionWithValues(IsOptional, Values)"
                class="option-input"
                v-bind:class="{
                  'active-input': getSelectionValid(
                    PlaceholderText,
                    RulesKey,
                    EnhancedSectionId,
                    Values,
                    DisplayPosition,
                    IsOptional
                  ),
                  isOptional: IsOptional,
                  isActive: completedItems >= index || IsOptional,
                  isStatic: !Values
                }"
                >{{
                  getSelectionValue(
                    PlaceholderText,
                    RulesKey,
                    EnhancedSectionId,
                    Values,
                    DisplayPosition,
                    false,
                    IsOptional
                  )
                }}</a
              >
            </div>

            <div class="option-tooltip" v-if="MoreInfo">
              <div class="option-tooltip-icon">
                <tool-tip class="tooltip-not-mobile" :moreinfo="MoreInfo">
                  <span v-html="MoreInfoResult"></span>
                </tool-tip>
              </div>
            </div>
          </div>
        </li>
      </ul>

      <ul v-if="item.isComplete" class="completedList">
        <li
          v-for="({
            LabelText,
            PlaceholderText,
            MoreInfo,
            RulesKey,
            EnhancedSectionId,
            DisplayPosition,
            Values,
            IsOptional,
            OptionHeaderImage
          },
          index) in item.sectionOptionValues"
          :key="`completedList-${index}`"
        >
          <div v-if="showOption(IsOptional, Values)" class="config">
            <span class="config-text">{{ LabelText }}</span>
            <span class="config-text config-text_bold">{{
              getSelectionValue(
                PlaceholderText,
                RulesKey,
                EnhancedSectionId,
                Values,
                DisplayPosition,
                true,
                IsOptional
              )
            }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="item.IsNextSectionAvailable" class="shelf shelf_lg">
      <div class="alertBox" v-if="!item.isComplete">
        <div class="alertBox-icon">
          <span class="material-icons">error</span>
        </div>
        <div class="alertBox-bd">
          <p class="alertBox-bd-text">
            Once options are selected above, remaining product option choices
            will appear. After selecting remaining options, you will be able to
            add product to cart or a quote.
          </p>
        </div>
      </div>
    </div>
    <div v-if="item.IsNextSectionAvailable" class="shelf shelf_xl">
      <div class="section-button" v-if="!item.isComplete">
        <button
          class="btn btn-primary"
          @click="saveAndContinue(item)"
          :disabled="isCompleted"
        >
          SAVE &amp; Continue
        </button>
      </div>
    </div>
    <div v-if="!item.IsNextSectionAvailable" class="shelf shelf_xl">
      <div class="section-button" v-if="!item.isComplete">
        <button
          class="btn btn-primary"
          @click="saveAndContinue(item, 'finished')"
          :disabled="isCompleted"
        >
          <span class="material-icons done-all-icon">
            done_all
          </span>
          I'm Finished
        </button>
        <p class="finished-message">
          Once you are finished, click the button to be able to add to your cart
          or quote.
        </p>
      </div>
    </div>
    <EnhancedProductOptionsModal
      :is-active="isEnhancedProductOptionsModal"
      @close="closeEnhancedOptions"
      @preselectOption="preselectOption"
      :modal-options="modalOptions"
      :modal-title="modalTitle"
      :header-description="optionheaderDescription"
      :header-image="headerImage"
      :section-id="item.sectionId"
      :dependent-property="dependentProperty"
      :is-part="isPart"
      :is-optional="isOptional"
      :optionindexinasection="indexOfAnOptionInASection"
    />
     <EnhancedProductOptionsModal
      :is-active="this.getIsCustomHPL"
      @close="closeCustomHPL"
      :modal-title="customHPLTitle"
    />
  </div>
</template>

<script>
import ToolTip from "../Enhanced/EnhancedTooltip.vue";
import EnhancedProductOptionsModal from "../Enhanced/ModalOption";
import { mapGetters } from "vuex";
import { getCustomPositionDescription } from "../../services/enhanced/PositionHelper";

export default {
  props: {
    item: {
      isComplete: Boolean,
      sectionId: Number,
      sectionOptionValues: Array,
      selectedOptions: Array
    },
    testSectionComplete: {
      type: Boolean,
      default: false
    },
    componentStateFinishClicked: {
      type: Boolean
    },
    // this needs to be referenced somewhere in the template so the component is rerendered when the bom is updated
    // removing this from the template will break it
    bomItemCount: {
      type: Number
    }
  },
  mounted() {
    this.updateSaveAndContinueItemToLatestSection();
    this.afterSectionMountScrollOptionsIntoView();
  },
  beforeUpdate() {
    const bomLength = this.getBomSourceOfTruth.length;
    if (true === this.componentStateFinishClicked && bomLength > 0) {
      // this event posts accesories and updates the database in the parent component
      this.$emit("bom-updated");
    }
  },
  data() {
    return {
      isEnhancedProductOptionsModal: false,
      sectionCompleted: false,
      modalOptions: [],
      modalTitle: "",
      optionheaderDescription: "",
      headerImage: "",
      dependentProperty: [],
      isPart: false,
      totalItems: 0,
      completedItems: 0,
      numberOptional: 0,
      currentSelections: [],
      totalSelections: 0,
      selectedArray: [],
      indexOfAnOptionInASection: null,
      customHPLTitle: "Enter Custom Color Details Below:",
      isCustomOptional: true
      // toolTipText: MoreInfo
    };
  },
  components: {
    ToolTip,
    EnhancedProductOptionsModal
  },
  computed: {
    ...mapGetters("product", ["getTestTogSectionEditMode"]),
    ...mapGetters("enhancedproduct", [
      "getSelectedOptions",
      "getSections",
      "getSeriesId",
      "getConfigurationId",
      "getVariantCode",
      "getSectionsNumberOfOptionalChoices"
      // "getOptional"
    ]),
    ...mapGetters("enhancedproduct", ["getIsCustomHPL"]),
    ...mapGetters("enhancedBom", ["getBomParts", "getBomSourceOfTruth"]),
    testShowSectionOpts() {
      if (this.getTestTogSectionEditMode) {
        return true;
      }
      return !this.testSectionComplete;
    },
    isCompleted: function() {
      if (this.isCustomOptional) {
      const required =
        this.totalItems - this.getSectionsNumberOfOptionalChoices;
      const completed = this.completedItems;      
      this.$root.$emit("imFinishedEvent", completed >= required ? false : true);
      return completed >= required ? false : true;
      } else {
      const required = this.totalItems ;
      const completed = this.completedItems;      
      this.$root.$emit("imFinishedEvent", completed >= required ? false : true);
      return completed >= required ? false : true;
      }
    },
    isOptional() {
      const optionValues = this.item.sectionOptionValues;
      if (0 === optionValues.length) {
        return false;
      }
      // IsOptional is set on all the optionValues
      return optionValues[0].IsOptional;
    }     
  },
  methods: {
    optionClickHandler(
      values,
      labelText,
      dependentProperty,
      isPart,
      IsOptional,
      index,
      optionHeaderImage,
      optionheaderDescription
    ) {
      if (!IsOptional) {
        if (!(this.completedItems >= index)) return false;
      }

      // if (values.length === 1 && !IsOptional) return false;
      
      if (values.length > 0) {
        this.modalOptions = values ? values : [];
        this.modalTitle = labelText ? labelText : "";
        this.indexOfAnOptionInASection = index;
        this.optionheaderDescription = optionheaderDescription
          ? optionheaderDescription
          : "";
        this.headerImage = optionHeaderImage ? optionHeaderImage : "";
        this.dependentProperty = dependentProperty ? dependentProperty : [];
        this.isEnhancedProductOptionsModal = true;
        this.isPart = isPart ? isPart : false;
        document.body.className += " no-scroll";
      }
    },
    getSelectionValue(
      PlaceholderText,
      RulesKey,
      EnhancedSectionId,
      Values,
      displayPosition,
      forSummarySection
    ) {
      if (
        this.getSelectedOptions[EnhancedSectionId] &&
        this.getSelectedOptions[EnhancedSectionId][RulesKey]
      ) {     
        if (this.getSelectedOptions[EnhancedSectionId]["TableLengthId"] && this.getSelectedOptions[EnhancedSectionId]["TableLengthId"]["TranslationCode"]) {
         if (this.getSelectedOptions[EnhancedSectionId]["TableLengthId"]["TranslationCode"] === "184") {
          this.isCustomOptional = false;
        } else {
          this.isCustomOptional = true;
        }        
        } else{
          this.isCustomOptional = true;
        }
        return this.getSelectedOptions[EnhancedSectionId][RulesKey].Text;
      } else {
        let posArr = [];
        let positionDescriptionForSummarySection = [];
        if (
          this.getSelectedOptions &&
          this.getSelectedOptions[EnhancedSectionId]
        ) {
          for (const key in this.getSelectedOptions[EnhancedSectionId]) {
            if (
              this.getSelectedOptions[EnhancedSectionId][key].Position &&
              this.getSelectedOptions[EnhancedSectionId][key].Position.length >
                0 &&
              this.getSelectedOptions[EnhancedSectionId][key].RulesKey ==
                RulesKey
            ) {
              let bayId = 0;
              if(this.getSelectedOptions[1].BayId !== undefined) {
               bayId =  this.getSelectedOptions[1].BayId.Value
              }
              let positionDescription = this.positionName(
                this.getSelectedOptions[EnhancedSectionId][key].Position,               
               bayId,
                this.getSelectedOptions[EnhancedSectionId][key].RulesKey
              );
              let bomItemDescription = this.getSelectedOptions[
                EnhancedSectionId
              ][key].Text
                ? this.getSelectedOptions[EnhancedSectionId][key].Text +
                  positionDescription
                : "";
              positionDescriptionForSummarySection.push(bomItemDescription);
              posArr.push(this.getSelectedOptions[EnhancedSectionId][key].Text);
            }
          }
        }
        if (posArr.length > 0) {
          if (forSummarySection) {
            return positionDescriptionForSummarySection.join(", ");
          } else {
            return posArr.join(", ");
          }
        } else {
          if (forSummarySection) {
            return "None";
          } else {
            return PlaceholderText;
          }
        }
      }
    },
    getSelectionValid(
      PlaceholderText,
      RulesKey,
      EnhancedSectionId,
      Values,
      isOptional
    ) {
      this.completedItems = Object.keys(
        this.getSelectedOptions[EnhancedSectionId]
      ).length;
      this.totalItems = this.getSections[EnhancedSectionId][
        "sectionOptionValues"
      ].length;
      if (
        (this.getSelectedOptions[EnhancedSectionId] &&
          this.getSelectedOptions[EnhancedSectionId][RulesKey]) ||
        (Values && Values.length == 1 && !Values[0].Position && !isOptional)
      ) {
        return true;
      } else {
        let posArr = [];
        if (
          this.getSelectedOptions &&
          this.getSelectedOptions[EnhancedSectionId]
        ) {
          for (const key in this.getSelectedOptions[EnhancedSectionId]) {
            if (
              this.getSelectedOptions[EnhancedSectionId][key].Position &&
              this.getSelectedOptions[EnhancedSectionId][key].Position.length >
                0 &&
              this.getSelectedOptions[EnhancedSectionId][key].RulesKey ==
                RulesKey
            ) {
              posArr.push(key);
            }
          }
        }
        if (posArr.length > 0) {
          return true;
        } else {
          return false;
        }
      }
    },
    closeEnhancedOptions() {
      this.isEnhancedProductOptionsModal = false;
      document.body.className = document.body.className.replace(
        "no-scroll",
        ""
      );
    },
    closeCustomHPL() {
      document.body.className = document.body.className.replace(
        "no-scroll",
        ""
      );
    },
    preselectOption(filteredOption) {
      this.$store.dispatch("enhancedproduct/updatedSelectedOption", {
        selectedOption: filteredOption
      });
      this.$forceUpdate();
    },
    showOption(isOptional, values) {
      if (isOptional && values.length < 1) {
        return false;
      } else {
        return true;
      }
    },
    // NOTE: any code changes also need to be reflected in the EnhancedProductImFinishedButton component
    saveAndContinue(item, type) {
      // for the I'm Finished button
      if ("finished" === type) {
        // this sends an event to the parent container that finished was clicked
        // the parent component handles the logic and api calls are made in beforeUpdate lifecycle method after the store has been updated
        this.$emit("finish-clicked", item);
      }

      this.$store.dispatch("enhancedproduct/saveAndContinue", item).then(() => {
        this.updateSaveAndContinueItemToLatestSection();
      });
    },
    updateSaveAndContinueItemToLatestSection() {
      this.$store.dispatch(
        "enhancedproduct/updateSaveAndContinueItem",
        this.item
      );
    },
    afterSectionMountScrollOptionsIntoView() {
      const firstSectionId = 1;
      // keeps from running when the first section loads
      if (this.item.sectionId && this.item.sectionId > firstSectionId) {
        const $section = this.$refs[this.item.sectionId];
        $section.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
    showOptionWithValues(isOptional, values) {
      // if (isOptional && values && values.length < 1) {
      //   return false;
      // } else {
      //   return true;
      // }

      let _valuesCount = 0;
      const _tmpSelectedOptions = this.getSelectedOptions;
      if (isOptional && values && values.length > 0) {
        for (let i = 0; i < values.length; i++) {
          if (
            values[i].DependentPropertyValues &&
            values[i].DependentPropertyValues.length > 0
          ) {
            for (let j = 0; j < values[i].DependentPropertyValues.length; j++) {
              if (values[i].DependentPropertyValues[j]) {
                for (const key in _tmpSelectedOptions) {
                  for (const optionKey in _tmpSelectedOptions[key]) {
                    if (
                      _tmpSelectedOptions[key][optionKey] &&
                      _tmpSelectedOptions[key][optionKey].Value ==
                        values[i].DependentPropertyValues[j]["Value"] &&
                      _tmpSelectedOptions[key][optionKey].RulesKey ==
                        values[i].DependentPropertyValues[j]["Key"]
                    ) {
                      _valuesCount++;
                    }
                  }
                }
              }
            }
          } else {
            return true;
          }
        }
        if (_valuesCount > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    positionName(pos, bayId, rulesKey) {
      return getCustomPositionDescription(pos, bayId, rulesKey);
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  margin-bottom: 45px;
  text-align: left;
  font-family: $font-family-sans-serif-regular;
}

.section.isCompleted {
  .inputList {
    display: none;
  }

  .completedList {
    display: block;
  }
}

.inputList > * + * {
  margin-top: 15px;
}

.section-hd {
  margin-bottom: 15px;
}

.section-hd-text {
  @include media-breakpoint-up(xs) {
    font-size: 20px;
  }

  @include media-breakpoint-up(sm) {
    font-size: 24px;
  }

  color: #333333;
  display: flex;
  align-items: center;

  &::after {
    content: "";
    flex: 1;
    margin-left: 1rem;
    height: 2px;
    background-color: #000000;
  }
}

.section-inputList > * {
  margin-bottom: 15px;
}

.section-button > * {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 49px;
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.75px;
  line-height: 24px;
}

.section-button-isHidden {
  display: none;
}

.option {
  margin-bottom: 25px;
}

.option-hd {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.option-hd-text {
  font-size: 14px;
  font-family: $font-family-sans-serif-regular;
  color: #666766;
}

.option-hd-optional {
  font-size: 14px;
  font-style: italic;
  font-family: $font-family-sans-serif-regular;
  text-transform: lowercase;
  color: #999999;
}

.alertBox {
  font-family: $font-family-sans-serif-regular;
  display: flex;
  padding: 15px;
  border: 1px solid #fed900;
  border-left-width: 5px;
  text-align: left;
  margin-bottom: 35px;

  > * {
    display: flex;
    align-items: center;
  }

  > *:first-child {
    width: 33.333%;
  }
  .alertBox-icon {
    .material-icons {
      font-size: 24px;
      color: rgb(254, 217, 0);
      margin: 0px 10px 0 0;
    }
  }
}

.alertBox-bd-text {
  font-size: 16px;
  color: #333333;
  margin: 0;
}

.option-tooltip {
  display: flex;

  > * {
    display: flex;
    align-content: center;
  }
}

.option-tooltip-icon > * {
  color: #25c0d0;
  font-size: 16px;
}

.option-input {
  width: 100%;
  padding: 14px 18px 14px 10px;
  display: block;
  margin: 0 0 5px;
  height: auto;
  border: 1px solid #d8d8d8;
  font-family: "FFDINWebPro", Helvetica, Arial, sans-serif;
  font-size: 16px;
  color: rgb(153, 153, 153);
  line-height: 1.5;
  background: #f3f3f3;
  border-radius: 0;
  z-index: 0;
  cursor: pointer;
}

.option-input.isStatic,
.option-input.isStatic.isActive {
  border: 1px solid #999999;
  background: #f3f3f3;
}

.option-input.isActive {
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='18' viewBox='0 0 18 18' width='18'%3E%3Cpath d='M0 0h24v24H0V0z' fill='none'/%3E%3Cpath d='M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z' fill='%23666667'/%3E%3C/svg%3E")
    #ffffff no-repeat;
  background-position: 95% 45%;
  cursor: pointer;
}

.active-input {
  color: rgb(51, 51, 51);
  font-family: "FFDINWebPro", Helvetica, Arial, sans-serif;
  font-size: 16px;
  letter-spacing: 0.25px;
}

.completedList > * + * {
  margin-top: 10px;
}

.config {
  display: flex;

  > * {
    width: 50%;
    padding: 0 20px 0 0;
  }
}

.config-text {
  font-size: 14px;
  color: #666766;
}

.config-text_bold {
  color: rgb(51, 51, 51);
  font-family: $font-family-sans-serif-medium;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.25px;
}

.shelf {
  margin-bottom: 10px;
}

.shelf_lg {
  margin-bottom: 25px;
}

.shelf_xl {
  margin-bottom: 35px;
}

.done-all-icon {
  margin: 0 10px 0 0;
}

.finished-message {
  color: rgb(102, 103, 102);
  font-family: $font-family-sans-serif-regular;
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 18px;
  margin-top: 5px;
  text-align: left;
  font-weight: normal;
  text-transform: none;
}
</style>
